module.exports = __webpack_public_path__ + "static/img/bg@2x (4).77b0b42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg@2x (4).jpg
// module id = kF1w
// module chunks = 14